import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: white;
  }

  .navbar {
    position: fixed;
    width: fill-available;
    width: -webkit-fill-available;
    width: -moz-available; 
}
`;

export const PageWrapper = styled.div`
    padding: 90px 74px 0px 74px;
`;

export const Container = styled.div`
    display: flex;
    min-height: 100vh;
    margin-bottom: 20px;
`;

export const RowWrapper = styled.div`
    display: flex;
    overflow-x: auto;
    gap: 15px;
    scrollbar-width: thin;
    scrollbar-color: transparent transparent; /* Adjust as needed for scrollbar appearance */

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

export const ColumnWrapper = styled.div`
    background-color: ${(props) => props.color || 'lightgray'};
    border-radius: 8px;
    margin: 0 15px 15px 0;
    padding: 15px;
    width: 292px;
    display: flex;
    flex-direction: column;
    height: 100%;

    ${(props) => props.disabled && `
        writing-mode: vertical-rl;
        text-orientation: mixed;
        width: 45px;

        & div {
            display:none;
        }
    `}
`;

export const ColumnHeader = styled.h2`
    font-size: 17.5px;
    color: ${(props) => props.color || '#333'};
    margin-bottom: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 17.5px;
    display: flex;
    justify-content: space-between;

    & i:hover {
        cursor: pointer;
    }

    ${(props) => props.disabled && `
        justify-content: start;
        margin: 0px;

        & i {
            padding-top: 14px;
        }
    `}
`;

export const CardWrapper = styled.div`
    background-color: #fff;
    margin-bottom: 8px;
    padding: 14px;
    border-radius: 6px;
    border: 1px solid #DEE2E6;
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.02), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
`;

export const CardTitle = styled.h3`
    color: #46389E;
    font-size: 13px;
    display: flex;
    align-items: center;
    margin-bottom: 7px;

    i {
        margin-right: 5px;
    }
`;

export const CardText = styled.p`
    font-size: 11px;
    margin-bottom: 7px;
    font-weight: 500;
    line-height: normal;
    color: #6c757d;
`;

export const CardDate = styled.div`
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 0;

    & div {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
    }

    & .target-date, .time-remaining {
        color: ${(props) => props.color || '#31363A'};
        font-size: 11px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px;
    }

    & span:last-child {
        color: #6C757D;
        font-size: 11px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px;
    }
`;

export const WorkspaceTitle = styled.h3`
    font-size: 24.5px;
    font-weight: 500;
    line-height: 29px;
    margin-bottom: 28px;
`;
